var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.60515 9.01425C7.75502 9.014 7.06553 8.32451 7.06528 7.47438L7.06528 -3.34591e-07L2.5482 -5.32039e-07C1.14087 -5.93555e-07 7.80648e-07 1.14087 7.19131e-07 2.5482L1.11385e-07 16.4518C4.9869e-08 17.8591 1.14087 19 2.5482 19L12.1716 19C13.579 19 14.7198 17.8591 14.7198 16.4518L14.7198 9.01425L8.60515 9.01425ZM14.7198 6.47999C14.7198 5.71322 14.374 4.98699 13.7792 4.50314L8.94557 0.571353C8.91869 0.549488 8.88961 0.530323 8.86196 0.509639L8.86196 5.31837C8.86217 6.16855 9.55164 6.85802 10.4018 6.85824L14.7198 6.85824L14.7198 6.47999Z",
    fill: "url(#paint0_linear_5012_48844)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5012_48844",
    x1: 14.7198,
    y1: 9.5,
    x2: 4.15258e-7,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3B1AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#977971"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickers);
export default __webpack_public_path__ + "static/media/tickers.17d42fcaba580e91749bef41d2ccc5e8.svg";
export { ForwardRef as ReactComponent };